<div>
  @if (userResource.status() === 'error') {
    <app-resource-load-error data-resource="user" message="profile.profileLoadError" (retry)="userResource.reload()" />
  } @else if (isLoading()) {
    <div class="relative min-h-[10rem] w-full">
      <korviu-loader></korviu-loader>
    </div>
  } @else if (user()) {
    <div class="flex flex-col md:flex-row gap-8 relative w-full">
      <div class="flex flex-col flex-1 w-full md:max-w-[21.4375rem]">
        <div class="w-full relative">
          <div class="profile-avatar-image-frame w-full aspect-[343/300] overflow-hidden rounded-t-[0.5rem]">
            <app-user-avatar-v2
              [user]="user()"
              [avatarUrl]="profileAvatarUrl()"
              [style.--avatar-border-radius]="'0'"
              [style.--avatar-object-position]="'center top'"
            />
          </div>
          <div class="referral-code absolute p-4 flex flex-col max-w-[calc(100%-2rem)] right-3 bottom-3">
            <span class="text-[#003555] text-[0.9375rem]">{{ 'profile.referralCode' | translate }}</span>
            <div class="flex gap-2 items-center">
              <span class="text-[#003555] font-bold text-[1.625rem]">{{ user()?.referralCode }}</span>
              <i class="cursor-pointer" (click)="copyReferralCode()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5.5028 4.62704L5.5 6.75V17.2542C5.5 19.0491 6.95507 20.5042 8.75 20.5042L17.3663 20.5045C17.0573 21.3782 16.224 22.0042 15.2444 22.0042H8.75C6.12665 22.0042 4 19.8776 4 17.2542V6.75C4 5.76929 4.62745 4.93512 5.5028 4.62704ZM17.75 2C18.9926 2 20 3.00736 20 4.25V17.25C20 18.4926 18.9926 19.5 17.75 19.5H8.75C7.50736 19.5 6.5 18.4926 6.5 17.25V4.25C6.5 3.00736 7.50736 2 8.75 2H17.75ZM17.75 3.5H8.75C8.33579 3.5 8 3.83579 8 4.25V17.25C8 17.6642 8.33579 18 8.75 18H17.75C18.1642 18 18.5 17.6642 18.5 17.25V4.25C18.5 3.83579 18.1642 3.5 17.75 3.5Z"
                    fill="#007DCB"
                  />
                </svg>
              </i>
            </div>
          </div>
        </div>
        <div class="pt-4 px-6 pb-6 flex flex-col w-full text-center card">
          <span class="text-[1.375rem]/[160%] font-bold text-[#222528]">{{ user().firstName }}</span>
          <span class="text-[0.9375rem]/[160%] text-[#505760]">{{ user().typeName }}</span>
        </div>
      </div>
      <div class="flex-1 min-w-0 flex flex-col gap-6 px-6 py-4 recent-activity-card">
        <div class="w-full gap-4 flex items-center">
          <span class="text-[#222528] text-[1.375rem]/[160%] font-bold flex-1 text-center md:text-left">{{
            'profile.recentActivity' | translate
          }}</span>
          <span
            class="text-[1.125rem]/[160%] text-[#007DCB] hidden md:inline-block cursor-pointer"
            (click)="goToRecentActivity()"
            >{{ 'profile.viewAll' | translate }}</span
          >
        </div>
        <div class="flex flex-col gap-2 w-full">
          @if (recentActivities().length) {
            @for (activity of recentActivities(); track activity.source_id) {
              <div class="p-2 flex flex-row gap-4 w-full border-b border-[#EEEEEF] last:border-b-0">
                <div
                  class="bg-[#E6F2FA] rounded-[0.5rem] min-h-[2rem] max-h-[2rem] min-w-[2rem] max-w-[2rem] md:min-h-[2.5rem] md:min-w-[2.5rem] md:max-h-[2.5rem] md:max-w-[2.5rem] flex items-center justify-center"
                >
                  <i>
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                      <path
                        d="M20.75 2.00195C21.7165 2.00195 22.5 2.78607 22.5 3.75331V6.79838C22.5 7.82334 21.9309 8.76338 21.0231 9.23787L14.7413 12.5208C16.3773 13.3431 17.5 15.0378 17.5 16.995C17.5 19.7585 15.2614 21.9988 12.5 21.9988C9.73858 21.9988 7.5 19.7585 7.5 16.995C7.5 15.0378 8.62271 13.3431 10.2587 12.5208L3.97693 9.23787C3.06913 8.76338 2.5 7.82334 2.5 6.79838V3.75331C2.5 2.78607 3.2835 2.00195 4.25 2.00195H20.75ZM12.5 13.4922C10.567 13.4922 9 15.0605 9 16.995C9 18.9295 10.567 20.4977 12.5 20.4977C14.433 20.4977 16 18.9295 16 16.995C16 15.0605 14.433 13.4922 12.5 13.4922ZM16 3.50212H9V10.1693L12.3843 11.9385C12.4568 11.9765 12.5432 11.9765 12.6157 11.9385L16 10.1683V3.50212ZM7.5 3.50212L4.25 3.50312C4.11193 3.50312 4 3.61513 4 3.75331V6.79838C4 7.26428 4.25869 7.69157 4.67133 7.90724L7.5 9.38468V3.50212ZM20.75 3.50312L17.5 3.50212V9.38468L20.3287 7.90724C20.7413 7.69157 21 7.26428 21 6.79838V3.75331C21 3.61513 20.8881 3.50312 20.75 3.50312Z"
                        fill="#007DCB"
                      />
                    </svg>
                  </i>
                </div>
                <div class="flex flex-col gap-2 flex-1 min-w-0 max-w-[75%]">
                  <span class="text-[1rem] md:text-[1.125rem]/[160%] text-[#2C3035] font-medium truncate max-w-full">
                    {{ activity.title }}
                  </span>
                  <span class="text-[1rem] md:text-[1.125rem]/[160%] text-[#505760]">
                    {{ activity.date + 'T00:00:00' | date: 'dd MMM' }}
                  </span>
                </div>
              </div>
            }
          } @else {
            <span class="p-2 text-[1rem] md:text-[1.125rem]/[160%] text-[#505760]">
              {{ 'korviuNoData.noData' | translate }}
            </span>
          }
        </div>
        <span
          class="text-[1.125rem]/[160%] text-[#007DCB] md:hidden inline-block cursor-pointer flex-1 text-center"
          (click)="goToRecentActivity()"
        >
          {{ 'profile.viewAll' | translate }}
        </span>
      </div>
    </div>
    <div class="mt-8">
      <app-tabs-v2 [tabs]="tabs()" [(selectedTab)]="selectedTab" />
    </div>
    <div class="py-6">
      @switch (selectedTab()) {
        @case (ETab.JOURNEY) {
          <app-journey-tab [user]="user()" />
        }
        @case (ETab.PERSONAL_INFORMATION) {
          @if (userPaymentAccountsResource.status() === 'error') {
            <app-resource-load-error
              data-resource="accounts"
              message="profile.paymentAccountsLoadError"
              (retry)="userPaymentAccountsResource.reload()"
            />
          } @else if (userPaymentAccountsResource.isLoading()) {
            <div class="relative min-h-[10rem]"><korviu-loader /></div>
          } @else {
            <app-personal-information-tab
              [user]="user()"
              [paymentAccounts]="paymentAccounts()"
              (okeeyCashAccountRemoved)="userResource.reload()"
            />
          }
        }
      }
    </div>
  } @else {
    <app-resource-load-error data-resource="user" message="profile.profileLoadError" (retry)="userResource.reload()" />
  }
</div>
